export const ATTACHMENT_TYPES = {
  ATTACHMENT_ASSET: "ATTACHMENT_ASSET",
};

export const ATTACHMENT_ID_NAMES = {
  [ATTACHMENT_TYPES.ATTACHMENT_ASSET]: "taskAssetID"
};